// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__CalibreFont_0019f0', '__CalibreFont_Fallback_0019f0'"},"className":"__className_0019f0","variable":"__variable_0019f0"};